/**
 * A tiny in-flight gate so background bulk work (the catalog's summary drain)
 * yields to interactive reads: paged/stats fetchers mark themselves while in
 * flight, and the drain awaits idleness before launching each partition —
 * on a thin connection the bulk transfer must never starve the read the user
 * is actually waiting on.
 */
let inFlight = 0
const waiters: (() => void)[] = []

export function beginInteractiveRead(): void {
  inFlight += 1
}

export function endInteractiveRead(): void {
  inFlight = Math.max(0, inFlight - 1)
  if (inFlight === 0) {
    for (const wake of waiters.splice(0)) wake()
  }
}

export function interactiveReadsInFlight(): number {
  return inFlight
}

/** Resolves immediately when idle, else after the last in-flight read ends. */
export function whenInteractiveReadsIdle(): Promise<void> {
  if (inFlight === 0) return Promise.resolve()
  return new Promise((resolve) => {
    waiters.push(resolve)
  })
}
